import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="filterbar"
export default class extends Controller {
  static targets = ["query", "form", "reset"]

  submit() {
    this.formTarget.requestSubmit()
  }
}
